import { api } from '../../../api/client';

export const certificatesValidationApi = {
  /**
   * Obtiene todos los certificados emitidos desde ms-validations de manera dinámica.
   * Retorna array ordenado por fechaEmision descendente.
   * @param {string} [tipo]
   */
  getAll: async (tipo = null) => {
    const query = typeof tipo === 'string' && tipo ? `?tipo=${encodeURIComponent(tipo)}` : '';
    const list = await api.get(`/validations/certificates${query}`);
    const all = Array.isArray(list) ? list : [];
    all.sort((a, b) => new Date(b.fechaEmision) - new Date(a.fechaEmision));
    return all;
  },

    search: (dataSearch) => api.post('/validations/certificates/search', dataSearch),
  /**
   * Obtiene un certificado específico por folio.
   * @param {string} folio
   */
  getByFolio: (folio) => api.get(`/validations/certificates/${encodeURIComponent(folio)}`),

  /**
   * Descarga el PDF de un certificado dado su folio.
   * @param {string} folio
   * @returns {Promise<Blob>}
   */
  downloadPdf: (folio) => {
    return api.getBlob(`/validations/certificates/${encodeURIComponent(folio)}/pdf`);
  },

  /**
   * Descarga el XML de un certificado dado su folio.
   * @param {string} folio
   * @returns {Promise<Blob>}
   */
  downloadXml: (folio) => {
    return api.getBlob(`/validations/certificates/${encodeURIComponent(folio)}/xml`);
  },

  /**
   * Genera un código QR para la URL de validación.
   * @param {string} contenido - URL a codificar
   * @param {number} tamano
   * @returns {Promise<{qr: string}>}
   */
  generateQr: (contenido, tamano = 150) =>
    api.get(`/validations/qr/generar?contenido=${encodeURIComponent(contenido)}&tamano=${tamano}`),
};
